module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/eo-sg/mobile-8b56e47e0d72f1321b9c8f2bddf37336.png";